import React, { useEffect, useState } from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"

const DoctorRatingDonut = ({ doctor }) => {
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (doctor && typeof doctor.rating === "number") {
      const rating = Math.max(0, Math.min(doctor.rating, 5)) // clamp between 0 and 5
      const remaining = 5 - rating
      setColumns([
        [doctor.doctorName || "Doctor", rating],
        ["Remaining", remaining],
      ])
    } else {
      setColumns([])
    }
  }, [doctor])

  if (!columns.length) return null

  const data = {
    columns: columns,
    type: "donut",
  }

  const donut = {
    title: `${doctor.rating} / 5`,
    width: 30,
    label: { show: true },
  }

  const color = {
    pattern: ["#2990DF", "#E8E8E8"],
  }

  const size = { height: 250 }

  return <C3Chart data={data} donut={donut} color={color} size={size} />
}

export default DoctorRatingDonut
